import React from 'react';
import { connect } from 'react-redux';
import { Link, withRouter } from 'react-router-dom';
import * as actions from '../store/actions/auth';
import Dropdown from 'react-bootstrap/Dropdown';
import Image from 'react-bootstrap/Image';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFacebook, faLinkedin, faInstagram, faTiktok } from '@fortawesome/free-brands-svg-icons'
import { useSelector, useDispatch } from 'react-redux';
import chartIcon from '../css/icon/inbox_white_18dp.png'
import WhatsApp from '@material-ui/icons/WhatsApp';
import Email from '@material-ui/icons/Email';
import ContactSupport from '@material-ui/icons/ContactSupport';
import CallIcon from '@material-ui/icons/Call';
import { toast } from 'react-toastify';
import ResponsiveSlideMenu from './ResponsiveSlideMenu/slide';
import "../components/ResponsiveSlideMenu/slide.css"
import HorizontalDropdowns from '../components/DeviceNav/deviceNav'
class CustomLayout extends React.Component {
    constructor() {
        super();
        this.state = {
            isCollapse: false,
            show:false
        }
    }

    handleClose=()=>{
        this.setState({
            show:false
        })
    }
    
    logout = () => {
        this.props.logout()
        this.props.history.push('/login');
        toast.success("You're successfully logout")
    }
    myAccount = () => {
        this.props.history.push('/my-account');
    }

    linkTo = (link) => {
        this.props.history.push(link)
    }
    login = () => {
        this.props.history.push('/login');
    }
    register= () => {
        this.props.history.push('/signup');
    }
    customToggle = React.forwardRef(({ onClick }, ref) => (
        <a href="" ref={ref}
            onClick={e => {
                e.preventDefault();
                onClick(e);
            }}
        >
            <i class="fa fa-user fa-lg " aria-hidden="true"></i>
        </a>
    ));

    render() {
       
        const listLength = this.cartItems? this.cartItems.length : 0;
        return (
          
            <div >
                <header>
                    <div>
                    <ResponsiveSlideMenu items={this.props.items} isAuthenticated={this.props.isAuthenticated} customToggle={this.customToggle} myAccount={this.myAccount} login={this.login} logout={this.logout} register={this.register}/>
                       
                      
       
              </div>
                    
              <HorizontalDropdowns/>
                </header>
                <div className=''style={{ background:"#F2F0EB", height: 'auto' }}>
                  
                        {this.props.children}
                    
                </div>
                <footer >
                    
                    <section className="copyright  p-2">
                        <div className="container  ">
                            <small className="pre-wrap">
                                <p className="ml-2 p-2 text-center"style={{color:'white'}}>
                                ©2025, cash4device.ca |<Link to="/terms"> Terms of Service</Link> |<Link to="/privacy">  Privacy Policy</Link>
                                </p>
                                <div className='mt-2 p-2 mr-2 text-center'>
                                    <a  href='https://www.facebook.com/profile.php?id=61553760729479#' className="btn btn-outline-light btn-social mx-1" target="_blank">
                                        <FontAwesomeIcon icon={faFacebook} />
                                    </a>
                                    <a href='https://www.instagram.com/cash4device.ca' className="btn btn-outline-light btn-social mx-1" target="_blank">
                                        <FontAwesomeIcon icon={faInstagram} />
                                    </a>
                                    <a href='https://www.linkedin.com/company/cash4device' className="btn btn-outline-light btn-social mx-1" target="_blank">
                                        <FontAwesomeIcon icon={faLinkedin} />
                                    </a>
                                   { /*<a href='https://www.linkedin.com/company/cash4device' className="btn btn-outline-light btn-social mx-1" target="_blank">
                                        <FontAwesomeIcon icon={faXTwitter} />
                                    </a>*/}
                                    <a href='https://www.tiktok.com/@cash4device' className="btn btn-outline-light btn-social mx-1" target="_blank">
                                        <FontAwesomeIcon icon={faTiktok} />
                                    </a>
                                                             
                                </div>
                            </small>
                        </div>
                    </section>
                </footer>

            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        items: state.cart.items.length
    }
}


const mapDispatchToProps = dispatch => {
    return {
        logout: () => dispatch(actions.logout())
    }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(CustomLayout));
